<form [formGroup]="parentForm">
  <div formGroupName="susType">
    <div class="subSectionHeaderWrapper">
      <div class="d-flex justify-content-between align-items-center subSectionHeader">
        <h5 class="m-0">SUS Type</h5>
        
        <div class="ms-auto d-flex align-items-center">
          <button 
            type="button" 
            class="btn btn-link p-0 text-decoration-none" 
            (click)="openHelpModal.emit('sw-maintenance-sus-type')" 
            data-bs-toggle="modal" 
            data-bs-target="#helpModal" 
            aria-label="Help"
          >
            <i class="bi bi-question-circle" style="font-size: 1.5rem; color: white"></i>
          </button>
          
        </div>
      </div>
    </div>    <div class="row">

      <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
        <div class="form-check">
          <input id="susTypeRb0" class="form-check form-check-inline" formControlName="susTypeRb"
                type="radio"
                [(ngModel)]="susTypeRb"
                (click)="submit()"
                value="Standard SUS">
          <label for="susTypeRb0" class="form-check-label">
            Standard SUS
          </label>
        </div>
      </div>

      <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
        <div class="form-check">
          <input id="susTypeRb1" class="form-check form-check-inline" formControlName="susTypeRb"
                type="radio"
                [(ngModel)]="susTypeRb"
                (click)="submit()"
                value="LCS SUS">
          <label for="susTypeRb1" class="form-check-label">
            LCS SUS
          </label>
        </div>
      </div>


    </div>
  </div>
</form>
